import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const DataTransformationForNro = lazy(() =>
  import("@scenes/DataTransformation/DataTransformationForNro").then((module) => ({
    default: module.DataTransformationForNro,
  }))
);

export const dataTransformationsNRO: NavigationRoutingObject = {
  Component: DataTransformationForNro,
  componentFeatureFlippers: ["data_transformations_nro_component"],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("data-transformation-menu-option", "Data Transformation"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("data-transformations-description-nav", "Build integrations that update user profiles with external data"),
  icon: "nav-system-data-transformation",
  featureLimitationKeys: ["can_only_view_landing_page_data_transformation"],
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("data_transformation_dashboard");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    data_transformations: makeAdditionalSearchableFeature({
      heading: t("data-transformation-menu-option", "Data Transformation"),
      pathname: "/dashboard/data_transformations/:dataTransformationId/:appGroupId",
      query: { dataTransformationId: "data_transformations" },
      description: t(
        "data-transformations-description-nav",
        "Build integrations that update user profiles with external data"
      ),
      additionalSearchTerms: [
        {
          keywords: [
            t("data-transformations-alt-keyword-1", "third-party webhooks"),
            t("data-transformations-alt-keyword-2", "automated integration"),
          ],
        },
      ],
    }),
  }),
  defaultRoute: "/dashboard/data_transformations/data_transformations/:appGroupId",
};
